import { IRtcState } from 'app/containers/rtc/RtcStateContext';

/*
 * This is a 'temporary' (let's see how it holds) workaround
 * for a problem that arised after we moved RTC state from redux to
 * react context. Now we cannot just grab latest state value outside of
 * a component
 * It basically uses same approach as FluentdLogger
 * A better solution would be to likely have a context-aware notify
 * instead of trying to blindly insert some generic context whenever
 * this is called
 */

export enum ErrorReportingContextEntry {
  rtcState = 'rtcState',
}

interface IErrorReportingContext {
  [ErrorReportingContextEntry.rtcState]?: IRtcState,
}

let errorReportingContext: IErrorReportingContext = {};

export const getErrorReportingContext = () => errorReportingContext;

export const setErrorReportingContextEntry = <
  K extends keyof IErrorReportingContext
>(key: K, value: IErrorReportingContext[K]) => {
  errorReportingContext = {
    ...errorReportingContext,
    [key]: value,
  };
};

export const removeErrorReportingContextEntry = <
  K extends keyof IErrorReportingContext
>(key: K): IErrorReportingContext[K] => {
  const { [key]: deleted, ...filtered } = errorReportingContext;

  errorReportingContext = filtered;
  return deleted;
};
